export const FormError = ({ error }: { error: string | null | undefined }) => {
  if (!error) return null;

  return <div className="text-center text-destructive">{error}</div>;
};
